import { TYPES as CUSTOM_CONTROL_TYPES } from 'actions/customControlActions';
import { handleActions } from 'redux-actions';

const initialState = {};

export default handleActions({
  [CUSTOM_CONTROL_TYPES.SHOW_CONTROL]: (state, action) =>
    Object.assign({}, action.content, action.data),
  [CUSTOM_CONTROL_TYPES.HIDE_CONTROL]: () => initialState,
  [CUSTOM_CONTROL_TYPES.TOGGLE_CONTROL]: (state, action) => {
    let newState = initialState;

    if (action.content.id !== state.id) {
      newState = Object.assign({}, action.content, action.data);
    }

    return newState;
  },
}, initialState);



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/customControlReducer.js
 **/